// @ts-nocheck
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  AfterViewInit,
  Injector,
  Optional,
  Host,
  SkipSelf,
  Output,
  EventEmitter,
  ElementRef,
  Renderer2,
  ChangeDetectorRef
} from "@angular/core";
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgModel,
  NgControl,
  ControlContainer
} from "@angular/forms";
import { MatSelect, MatSelectChange } from "@angular/material/select";


import { CustomErrorStateMatcher, FormFieldType, ComplexListItem, CriticalError, ADPResourceService as ResourceService, ElementBase } from "digital-core";

@Component({
  selector: "adp-complex-select",
  templateUrl: "./adp-complex-select.component.html",
  styleUrls: ["./adp-complex-select.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: adpComplexSelectComponent,
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: adpComplexSelectComponent,
      multi: true
    }
  ]
})
export class adpComplexSelectComponent extends ElementBase<string>
  implements AfterViewInit, OnInit {
  @ViewChild(NgModel) model: NgModel;
  @ViewChild(MatSelect) matSelect: MatSelect;
  @Input() required: boolean;
  @Input() placeholder: string;
  @Input() hint?: string;
  @Input() patternHelp?: string;

  @Output() selectionChange = new EventEmitter<MatSelectChange>();

  @Input() controlMask?: string;

  @Input() listItems: ComplexListItem[];
  @Input() value: any;

  @Input() filter: string;

  @Input() customIcon: boolean;

  @Input() iconPosition: 'left' | 'right' = 'left';

  modelName: string;
  placeHolder: string;
  customMatcher = new CustomErrorStateMatcher();

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.matSelect.ngControl = this.injector.get(NgControl, null);
      // hacky way to make material control invalid when paren is invalid
    });
  }
  constructor(
    protected injector: Injector,
    protected resourcesService: ResourceService,
    @Optional()
    @Host()
    @SkipSelf()
    protected controlContainer: ControlContainer,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
  ) {
    super(injector, resourcesService, controlContainer);
    this.fieldType = FormFieldType.Select;
  }

  ngOnInit() {
    if (!this.resourceData) {
      this.isInvalid = true;
      this.isVisible = false;
      throw new CriticalError(`The resource data can't be empty - ${this.fieldType} - ${this.getFieldName}`);
    } else {
      this.isVisible = !this.resourceData?.Hidden;

      // if(!this.isVisible && this.filter != null){
      //   this.isVisible = true;
      // }
      // get and apply filter
      if (this.resourceData?.Filter != null && this.filter != null && this.filter !== undefined) {

        if (this.resourceData?.Filter.indexOf(this.filter) > -1) {
          this.isVisible = true;
        } else {
          this.isVisible = false;
        }

      }

      this.InitControl();
    }

    if (!this.isVisible) {
      this.renderer.setStyle(this.elementRef.nativeElement.parentElement, 'display', 'none');
    }

    // adding require indicator
    this.placeHolder = (this.required) ? this.resourceData?.PlaceHolder + " *" : this.resourceData?.PlaceHolder;

    this.cd.detectChanges();

  }

  protected InitControl() {
    super.InitControl();
    this.placeholder = this.resourceData?.PlaceHolder;
    this.required = this.resourceData?.IsRequired ? this.resourceData?.IsRequired : this.required;
  }

  changeSelection(event) {
    this.selectionChange.emit(event);
  }

  updateResource(resource){
    if(resource){
      this.resourceData = resource;
      this.ngOnInit();
    }
  }

}
